/* eslint-disable import/no-cycle */
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useStore} from './useStore';
import {useMount} from './useMount';

const useInspectionTaskExecutionModal = () => {
  const store = useStore();
  const {t} = useTranslation();
  const [pendingModalVisible, setPendingModalVisible] = useState(false);
  const [selectedPendingTask, setSelectedPendingTask] = useState(null);
  const [selectedInspectionTask, setSelectedInspectionTask] = useState(null);
  const onModalClose = () => {
    setSelectedPendingTask(null);
    setSelectedInspectionTask(null);
    setPendingModalVisible(false);
  };

  useMount(() => {
    store.roleStore.loadAll();
  });

  const handleOpen = (pendingTask, inspectionTask = null) => {
    let pendingGroupTasks = [pendingTask];
    if (pendingTask?.inspectionTaskGroup?.id) {
      pendingGroupTasks = store.inspectionTaskPendingStore
        .getByInspectionTaskGroupId(pendingTask.inspectionTaskGroup.id);
    }
    let missingRole;
    pendingGroupTasks.forEach((pendingGroupTask) => {
      const requiredRoleId = (pendingTask) ? pendingGroupTask.inspectionTask?.requiredRoleId
        : inspectionTask?.requiredRoleId;
      if (requiredRoleId && !store.authStore.user?.hasRole(requiredRoleId)) {
        missingRole = requiredRoleId;
      }
    });
    if (pendingTask?.pausedByUserId) {
      store.flashMessageStore.addFlashMessage({
        type: 'info', title: t('inspectionTask.paused'),
      });
    } else if (missingRole) {
      const role = store.roleStore.getById(missingRole);
      store.flashMessageStore.addFlashMessage({
        type: 'error', title: t('inspectionTask.missingRole', {role: role?.name || missingRole}),
      });
    } else {
      store.inspectionTaskStore.load((pendingTask) ? pendingTask.inspectionTask.id : inspectionTask?.id)
        .then((detailedTask) => {
          store.documentStore.loadMany(detailedTask.documentIds).then(() => {
            setSelectedPendingTask(pendingTask);
            setSelectedInspectionTask(inspectionTask);
            setPendingModalVisible(true);
          });
        });
    }
  };

  return {
    open: handleOpen,
    inspectionTaskExecutionModalProps: {
      visible: pendingModalVisible,
      setVisible: setPendingModalVisible,
      inspectionTask: selectedInspectionTask,
      pendingInspectionTask: selectedPendingTask,
      onCancel: onModalClose,
    },
  };
};

export default useInspectionTaskExecutionModal;
